import { MapPin, Phone, Clock, Navigation } from "lucide-react";
import { SITE } from "../data/site";
import { Reveal, Overline } from "./Reveal";
import { OrderButton } from "./OrderDialog";
import { useLang } from "../i18n";

export const Contact = () => {
    const { t } = useLang();
    return (
    <section id="contact" data-testid="contact-section" className="relative py-24 sm:py-32 bg-onyx/40">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
            <Reveal className="mb-12">
                <Overline>{t("contact.overline")}</Overline>
                <h2 className="mt-4 font-serif text-4xl sm:text-5xl lg:text-6xl text-cream leading-[1.05]">
                    {t("contact.h1a")} <span className="italic gold-text">{t("contact.h1b")}</span>
                </h2>
            </Reveal>

            <div className="grid lg:grid-cols-5 gap-8 lg:gap-12 items-stretch">
                <Reveal className="lg:col-span-2">
                    <div className="gold-border rounded-3xl bg-elevated/60 p-8 sm:p-10 h-full flex flex-col">
                        <p className="font-cinzel text-lg tracking-[0.2em] text-cream">ROYAL TADKA</p>
                        <div className="mt-8 space-y-6 text-sm">
                            <div className="flex gap-4">
                                <MapPin className="w-5 h-5 text-saffron-bright shrink-0 mt-0.5" strokeWidth={1.5} />
                                <a
                                    data-testid="contact-address"
                                    href={SITE.mapsUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="text-stone-300 leading-relaxed hover:text-saffron-glow transition-colors duration-300 underline-offset-4 hover:underline"
                                >
                                    {SITE.addressLine1}
                                    <br />
                                    {SITE.addressLine2}
                                </a>
                            </div>
                            <div className="flex gap-4">
                                <Phone className="w-5 h-5 text-saffron-bright shrink-0 mt-0.5" strokeWidth={1.5} />
                                <a
                                    data-testid="contact-phone-link"
                                    href={SITE.phoneHref}
                                    className="text-stone-300 hover:text-saffron-glow transition-colors duration-300"
                                >
                                    {SITE.phoneDisplay}
                                </a>
                            </div>
                            <div className="flex gap-4">
                                <Clock className="w-5 h-5 text-saffron-bright shrink-0 mt-0.5" strokeWidth={1.5} />
                                <p data-testid="contact-hours" className="text-stone-300 leading-relaxed">
                                    {t("contact.hoursLabel")}
                                    <br />
                                    11:00 – 22:00
                                </p>
                            </div>
                        </div>

                        <div className="mt-auto pt-10 flex flex-col gap-3">
                            <OrderButton testId="contact-order-button" className="w-full py-4 text-sm">
                                {t("misc.orderOnline")}
                            </OrderButton>
                            <div className="grid grid-cols-2 gap-3">
                                <a
                                    data-testid="contact-call-button"
                                    href={SITE.phoneHref}
                                    className="inline-flex items-center justify-center gap-2 rounded-full gold-border py-3.5 text-xs font-semibold tracking-[0.12em] text-cream hover:border-saffron/60 hover:text-saffron-glow transition-[border-color,color] duration-300"
                                >
                                    <Phone className="w-4 h-4" /> {t("contact.call")}
                                </a>
                                <a
                                    data-testid="contact-directions-button"
                                    href={SITE.mapsUrl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="inline-flex items-center justify-center gap-2 rounded-full gold-border py-3.5 text-xs font-semibold tracking-[0.12em] text-cream hover:border-saffron/60 hover:text-saffron-glow transition-[border-color,color] duration-300"
                                >
                                    <Navigation className="w-4 h-4" /> {t("contact.directions")}
                                </a>
                            </div>
                        </div>
                    </div>
                </Reveal>

                <Reveal delay={0.15} className="lg:col-span-3">
                    <div
                        data-testid="contact-map"
                        className="gold-border rounded-3xl overflow-hidden h-[340px] sm:h-full min-h-[340px] relative"
                    >
                        <iframe
                            title="Royal Tadka — Kalwaryjska 58, Kraków map"
                            src={SITE.mapsEmbed}
                            className="absolute inset-0 w-full h-full grayscale-[35%] contrast-[1.05]"
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                            allowFullScreen
                        />
                    </div>
                </Reveal>
            </div>
        </div>
    </section>
);
};

